module.exports = __webpack_public_path__ + "static/media/fm.2a798cdb.svg";